import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import DownIcon from 'assets/images/sort-down.svg';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => (props.width ? props.width : '100%')};

  span {
      color: ${props => (props.color ? props.color : '#35447d')};
      font-size: 1rem;
  }
  .select-wrapper {
    background: ${props => (props.background ? props.background : '#e1e1e1')} url(${DownIcon}) no-repeat 98% 50%;
    background-size: 12px;
    border: none;
    border-bottom: 1px solid ${props => (props.color ? props.color : '#35447d')};
    font-size: 1.9rem;
    overflow: hidden;
    width: 100%;

    @media (max-width: 768px) {
      background-size: 10px;
      background-position: 98% 40%;
    }

    select {
        padding: 5px 2px 10px 2px;
        width: 130%;
        border: none;
        box-shadow: none;
        background: transparent;
        background-image: none;
        color: ${props => (props.color ? props.color : '#35447d')};
        -webkit-appearance: none;
    }
    select:focus {
        outline: none;
    }
  }
`;

const Dropdown = props => (
  <Wrapper>
    <span>{props.hint}</span>
    <div className="select-wrapper">
      <select defaultValue={props.value} onChange={e => props.onChange(e, props.name)}>
        {props.options.map(option => (
          <option value={option.value}>{option.value}</option>
        ))}
      </select>
    </div>
  </Wrapper>
);

Dropdown.propTypes = {
  hint: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.string.isRequired,
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js